import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import UserManagement from '../views/UserManagement.vue'
import ClientManagement from '../views/ClientManagement.vue'
import ClientCompanies from '../views/ClientCompanies.vue'
import Activity from '../views/Activity.vue'
import OrderHistory from '../views/OrderHistory.vue'
import Documents from '../views/Documents.vue'
import Notifications from '../views/Notifications.vue'
import AuditTrail from '../views/AuditTrail.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import Register from '../views/Register.vue'
import ClearanceRequests from '../views/ClearanceRequests.vue'
import PendingDoctors from '../views/PendingDoctors.vue'
import Payfast from '../views/Payfast.vue'
import TestAPI from '../views/TestAPI.vue'
import DoctorUpdates from '../views/DoctorUpdates.vue'
import ManageAds from '../views/ManageAds.vue'
import ManageProducts from '../views/ManageProducts.vue'
import ManageOrders from '../views/ManageOrders.vue'
import ManageArticles from '../views/ManageArticles.vue'
import ManageRefunds from '../views/ManageRefunds.vue'
import ManageSubscriptions from '../views/ManageSubscriptions.vue'
import Subscriptions from '../views/Subscriptions.vue'
import Refunds from '../views/Refunds.vue'
import Groups from '../views/Groups.vue'
import ReportedMessages from '../views/ReportedMessages.vue'
import DataDeletionRequests from '../views/DataDeletionRequests.vue'
import AbuseReports from '../views/AbuseReports.vue'


import { auth } from "../../firebaseConfig.js";
import { onAuthStateChanged } from 'firebase/auth'

import { getUserProfileByAuth } from "@/utils/firestoreUtil";

import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/userManagement',
    name: 'User Management',
    component: UserManagement,
    meta: {
      requiresAuth: true,
      requiresAdmin: false,
    }
  },
  {
    path: '/clientManagement',
    name: 'Client Management',
    component: ClientManagement,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/clientCompanies',
    name: 'Client Companies',
    component: ClientCompanies,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/refunds',
    name: 'Refund Requests',
    component: Refunds,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/orderHistory',
    name: 'Order History',
    component: OrderHistory,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/documents',
    name: 'Documents',
    component: Documents,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/auditTrail',
    name: 'Audit Trail',
    component: AuditTrail,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/clearanceRequests',
    name: 'Clearance Requests',
    component: ClearanceRequests,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/forgotPassword',
    name: 'Forgot Password',
    component: ForgotPassword
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/payfast',
    name: 'Payfast',
    component: Payfast,
    meta: {
      requiresAuth: false,
      requiresAdmin: false,
    }
  },
  {
    path: '/testAPI',
    name: 'Test API',
    component: TestAPI,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/doctorUpdates',
    name: 'Doctor Updates',
    component: DoctorUpdates,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/manageAds',
    name: 'Manage Ads',
    component: ManageAds,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/manageOrders',
    name: 'Manage Orders',
    component: ManageOrders,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/manageRefunds',
    name: 'Manage Refunds',
    component: ManageRefunds,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
   {
    path: '/manageProducts',
    name: 'Manage Products',
    component: ManageProducts,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
     {
    path: '/manageSubscriptions',
    name: 'Manage Subscriptions',
    component: ManageSubscriptions,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component:Subscriptions,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/manageArticles',
    name: 'Manage Articles',
    component: ManageArticles,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/groups',
    name: 'Groups',
    component: Groups,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/reportedMessages',
    name: 'Reported Messages',
    component: ReportedMessages,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/dataDeletionRequests',
    name: 'Data Deletion Requests',
    component: DataDeletionRequests,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
  {
    path: '/abuseReports',
    name: 'Abuse Reports',
    component: AbuseReports,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const getUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe()
      resolve(user)
    }, reject)
  })
}


const getFirestoreUser = async (authUser) => {
  if (!authUser) return null;

  const tempUser = await getUserProfileByAuth({
    email: authUser.email,
    uid: authUser.uid,
  });

  if (!tempUser) return null;

  if (!tempUser.email && authUser.email) {
    tempUser.email = authUser.email;
  }

  store.commit("setUser", tempUser);
  return tempUser;
};

router.beforeEach(async (to, from, next) => {
  console.log('to: ', to.path);
  if (localStorage.getItem('LastRoute') && localStorage.getItem('LastRoute') != to.path) {
    localStorage.removeItem("ViewedUser");
    localStorage.removeItem("ViewedRequest");
  }

  localStorage.setItem('LastRoute', to.path);

  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const requiresAdmin = to.matched.some(route => route.meta.requiresAdmin);
  const authUser = await getUser();

  let user = store.state.user;

  if (authUser && (!user || !user.email)) {
    user = await getFirestoreUser(authUser);
  }

  if (requiresAuth && !authUser) {
    return next('/');
  }

  if (requiresAdmin) {
    if (!user || user.userType != 'Admin') {
      return next('/');
    }
  }

  return next();
});

export default router

